import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Loading() {
  return (
    <Box sx={{ display: 'flex', width:"100%", height:"50vh"}}>
      <CircularProgress style={{margin:"5rem auto", color:"#f49f21"}} />
    </Box>
  );
}